const theme = {
  colors: {
    primary: '#667eea',
    secondary: '#764ba2',
    accent: '#f6ad55',
    textPrimary: '#1a202c',
    textMuted: '#718096',
    bodyBg: '#f7fafc',
    surface: '#ffffff',
    surfaceMuted: '#edf2f7',
  },
  fonts: {
    heading: "'Noto Sans KR', 'Poppins', 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'Noto Sans KR', 'Inter', 'Helvetica Neue', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  },
  layout: {
    maxWidth: '1200px',
  },
  shadows: {
    xl: '0 25px 50px rgba(0, 0, 0, 0.15)',
    lg: '0 20px 35px rgba(15, 23, 42, 0.18)',
    md: '0 10px 25px rgba(15, 23, 42, 0.12)',
  },
  transitions: {
    default: 'all 220ms ease',
  },
};

export default theme;

